/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react' // AG-GRID: added useMemo
import { AgGridReact } from 'ag-grid-react' // AG-GRID
import '../../../assets/styles/styles.scss'
import './menu.scss'
import '../../../assets/styles/inner/table.scss'
import { EditModal, DeleteConf } from '../../../common';
import CustomSelect from "../../../common/CustomSelect"; 
import editIcon2 from "../../../assets/edit2.svg";
import deleteIcon from "../../../assets/icons/deleteRole.svg";
import searchIcon from '../../../assets/icons/search.svg' // SEARCH
import { sectorTypesList } from '../../../utils/configs'
import { useTranslation } from 'react-i18next'
import usePermissions from '../../../utils/userPermissions'
import { APIEndpoint } from '../../../utils/axios'
import useToastAssist from '../../../utils/useToastAssist'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import LoadingGIF from '../../../assets/loadingIn.gif'

const centerCell = { textAlign: 'center' };
const wrapCell = { whiteSpace: 'normal', overflowWrap: 'anywhere', lineHeight: 'normal', padding: '8px 12px' };
const FALLBACK_MSG = 'Configure an airline-specific Meal Policy to enable editing.';


const ActionsRenderer = ({ context, data }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px', width: '100%' }}>
    <button
      type="button"
      onClick={() => context.onEdit(context.type, data)}
      disabled={context.isFallback}
      title={context.isFallback ? FALLBACK_MSG : 'Edit'}
      aria-label="Edit"
      style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', opacity: context.isFallback ? 0.4 : 1 }}
    >
      <img className="icon-size" alt="" src={editIcon2} />
    </button>
    <button
      type="button"
      onClick={() => context.onDelete(context.type, data)}
      disabled={context.isFallback}
      title={context.isFallback ? FALLBACK_MSG : 'Delete'}
      aria-label="Delete"
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', opacity: context.isFallback ? 0.4 : 1 }}
    >
      <img src={deleteIcon} alt="delete" style={{ width: '18px', height: '18px', display: 'block' }} />
    </button>
  </div>
);

const HEADER_INFO = {
  'SVC': 'Service',
  'ETD From': 'Estimated Time of Departure - from',
  'ETD To': 'Estimated Time of Departure - to',
  'BC': 'Business Class',
  'EY': 'Economy Class',
  'CO': 'CO - add full form here',
  'CR': 'CR - add full form here',
};

const HeaderWithInfo = ({ displayName, info }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '6px', width: '100%' }}>
    <span>{displayName}</span>
    {info && <span className="header-info-icon" aria-label={info}>i</span>}
  </div>
);

const DOM_SB_COLS = [
  { headerName: 'Duration', valueGetter: p => p.data ? `${p.data.from} - ${p.data.to} min` : '', flex: 4 },
  { headerName: 'SVC', field: 'svc', flex: 3 },
];
const DOM_MSP_COLS = [
  { headerName: 'ETD From', field: 'from' },
  { headerName: 'ETD To', field: 'to' },
  { headerName: 'Category', field: 'category', cellStyle: centerCell },
  { headerName: 'BC', valueGetter: p => p.data?.meals?.BC || '-', cellStyle: centerCell },
  { headerName: 'EY', valueGetter: p => p.data?.meals?.EY || '-', cellStyle: centerCell },
  { headerName: 'CO', valueGetter: p => p.data?.meals?.CO || '-', cellStyle: centerCell },
  { headerName: 'CR', valueGetter: p => p.data?.meals?.CR || '-', cellStyle: centerCell },
];
const DOM_SC_COLS = [
  { headerName: 'SVC', field: 'svc', flex: 1 },
  { headerName: 'Category', field: 'category', flex: 1 },
  { headerName: 'Domestic Service Category', field: 'domesticServiceCategory', flex: 2, autoHeight: true, wrapText: true, cellStyle: wrapCell },
  { headerName: 'BC', valueGetter: p => p.data?.meals?.BC || '-', flex: 3, autoHeight: true, wrapText: true, cellStyle: wrapCell },
  { headerName: 'EY', valueGetter: p => p.data?.meals?.EY || '-', flex: 3, autoHeight: true, wrapText: true, cellStyle: wrapCell },
];
const INT_SB_COLS = [
  { headerName: 'Duration', valueGetter: p => p.data ? `${p.data.from} - ${p.data.to} min` : '' },
  { headerName: 'SVC', field: 'svc', cellStyle: centerCell },
  { headerName: 'Meals', field: 'meals', cellStyle: centerCell },
];

const MealGrid = ({ type, rowData, columns, editable, isFallback, onEdit, onDelete }) => {
  const columnDefs = useMemo(() => [
    ...columns.map(col => HEADER_INFO[col.headerName] ? {
      ...col,
      headerComponentFramework: HeaderWithInfo,
      headerComponentParams: { info: HEADER_INFO[col.headerName] },
      headerTooltip: HEADER_INFO[col.headerName],
    } : col),
    ...(editable ? [
      { headerName: 'Actions', width: 120, maxWidth: 120, flex: 0, sortable: false, cellRendererFramework: ActionsRenderer, cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
    ] : []),
  ], [columns, editable]);

  return (<>
     <div className="table-header"></div>
    <div className="ag-theme-alpine-dark meal-grid" style={{ width: '100%' }}>
      <style>{`
        .meal-grid .ag-header-cell-label { justify-content: flex-start !important; width: 100%; }
        .meal-grid .ag-header-cell-text { text-align: left !important; }
        .meal-grid .ag-cell { display: flex; align-items: center; justify-content: flex-start !important; text-align: left !important; }

        /* keep the Actions column centered (header and icons) */
        .meal-grid .ag-header-cell[col-id="Actions"] .ag-header-cell-label { justify-content: center !important; }

        .meal-grid .header-info-icon {
          display: inline-flex; align-items: center; justify-content: center;
          width: 14px; height: 14px; border-radius: 50%;
          border: 1px solid currentColor; font-size: 10px; font-style: italic;
          font-weight: 700; cursor: help; opacity: 0.8;
        }
        .meal-grid .header-info-icon:hover { opacity: 1; }
      `}</style>
      <AgGridReact
        rowData={rowData || []}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        context={{ type, isFallback, onEdit, onDelete }}
        suppressCellFocus={true}
        tooltipShowDelay={0}
        defaultColDef={{ flex: 1, minWidth: 90, resizable: false, sortable: false }}
        overlayNoRowsTemplate={'<span>No data available</span>'}
        getRowClass={(p) => (p.node.rowIndex % 2 === 0 ? 'tableEvenRowClass' : 'tableRowClass')}
      />
    </div>
  </>
  
  );
};

export const MealPolicy = props => {
  const { t, ready } = useTranslation()
  const { toastSuccess, toastError } = useToastAssist()

  const [data, setData] = useState({
    domestic: { serviceBands: [], mealServicePolicies: [], serviceCategories: [] },
    international: { serviceBands: [], mealUplifts: [] }
  });

  const [loading, setLoading] = useState(true);

  const [state, setState] = useState({
    sectorType: [{ key: 1, label: 'Domestic', value: "domestic" }],
    sectorTypes: sectorTypesList
  });

  const [modalState, setModalState] = useState({
    isOpen: false,
    type: null,
    item: null,
    title: '',
    errorMsg: ''
  });

  const [deleteState, setDeleteState] = useState({
    isOpen: false,
    type: null,
    item: null,
    isDeleting: false
  });

  const { hasPermission: editMealPolicy } = usePermissions('edit', "configuration.fsc.meal-policy");

  const [currentAirline, setCurrentAirline] = useState(
    localStorage.getItem('selectedAirline') || 'AKASA'
  );

  const [scSearch, setScSearch] = useState(''); // SEARCH

  const fetchMealPolicy = async (airline) => {
    try {
      setLoading(true);
      const targetAirline = airline || currentAirline;
      const res = await APIEndpoint.get(`mealPolicy?airlineId=${encodeURIComponent(targetAirline)}`);
      if (res && res.domestic && res.international) {
        setData({
          domestic: res.domestic,
          international: res.international
        });
      }
    } catch (err) {
      console.error('Error fetching meal policy:', err);
      toastError('Failed to load meal policy data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMealPolicy();
  }, [currentAirline]);

  const handleSectorType = selectedData => {
    setState(prev => ({ ...prev, sectorType: [selectedData] }))
  }

  const onCloseEditMeals = () => {
    setModalState(prev => ({ ...prev, isOpen: false, item: null, errorMsg: '' }))
  }

  const domData = data.domestic || { serviceBands: [], mealServicePolicies: [], serviceCategories: [] };
  const intData = data.international || { serviceBands: [], mealUplifts: [] };

  const intUpliftLevels = [...new Set(
    (intData.mealUplifts || []).flatMap(row => Object.keys(row.uplifts || {}))
  )].sort((a, b) => parseFloat(a) - parseFloat(b));

  // Search: filtered row
  const filteredServiceCategories = useMemo(() => {
    const term = scSearch.trim().toLowerCase();
    const rows = domData.serviceCategories || [];
    if (!term) return rows;
    return rows.filter(r =>
      [r.svc, r.category, r.domesticServiceCategory, r.meals?.BC, r.meals?.EY]
        .some(v => String(v ?? '').toLowerCase().includes(term))
    );
  }, [domData.serviceCategories, scSearch]);

  const intMuCols = useMemo(() => [
    { headerName: 'ETD From', field: 'from', minWidth: 90, flex: 0, width: 100 },
    { headerName: 'ETD To', field: 'to', minWidth: 90, flex: 0, width: 100 },
    { headerName: 'Category', field: 'category', minWidth: 90, flex: 0, width: 100, cellStyle: centerCell },
    ...intUpliftLevels.map(lvl => ({
      headerName: String(lvl),
      valueGetter: p => p.data?.uplifts?.[lvl] || '-',
      minWidth: 110,
      cellStyle: { ...centerCell, ...wrapCell },
      autoHeight: true,
      wrapText: true,
    })),
  ], [intData.mealUplifts]);

  const onDelete = (type, item) => {
    const isDom = type.startsWith('dom-');
    const isFallback = isDom ? domData.isFallback : intData.isFallback;
    if (isFallback) {
      toastError('Default configuration shown — airline-specific policy not configured. Configure an airline-specific Meal Policy to enable editing.');
      return;
    }
    setDeleteState({ isOpen: true, type, item, isDeleting: false });
  };

  const onConfirmDelete = async () => {
    const { type, item } = deleteState;
    setDeleteState(prev => ({ ...prev, isDeleting: true }));
    try {
      const newData = JSON.parse(JSON.stringify(data));
      if (type.startsWith('dom-')) {
        const coll = type === 'dom-sb' ? 'serviceBands' : type === 'dom-msp' ? 'mealServicePolicies' : 'serviceCategories';
        newData.domestic[coll] = (newData.domestic[coll] || []).filter(x => x.id !== item.id);
      } else {
        const coll = type === 'int-sb' ? 'serviceBands' : 'mealUplifts';
        newData.international[coll] = (newData.international[coll] || []).filter(x => x.id !== item.id);
      }
      const res = await APIEndpoint.put(`mealPolicy?airlineId=${encodeURIComponent(currentAirline)}`, newData);
      if (res && res.domestic && res.international) {
        setData({ domestic: res.domestic, international: res.international });
      } else {
        setData(newData);
      }
      toastSuccess('Record deleted successfully');
    } catch (err) {
      console.error('Error deleting record:', err);
      toastError('Failed to delete record');
    }
    setDeleteState({ isOpen: false, type: null, item: null, isDeleting: false });
  };

  const onEdit = (type, item) => {
    const isDom = type.startsWith('dom-');
    const isFallback = isDom ? domData.isFallback : intData.isFallback;
    if (isFallback) {
      toastError('Default configuration shown — airline-specific policy not configured. Configure an airline-specific Meal Policy to enable editing.');
      return;
    }

    let title = '';
    const isAdd = !item;
    if (type === 'dom-sb') title = isAdd ? 'Add Domestic Service Band' : 'Edit Domestic Service Band';
    else if (type === 'dom-msp') title = isAdd ? 'Add Domestic Meal Service Policy' : 'Edit Domestic Meal Service Policy';
    else if (type === 'dom-sc') title = isAdd ? 'Add Domestic Service Category' : 'Edit Domestic Service Category';
    else if (type === 'int-sb') title = isAdd ? 'Add International Service Band' : 'Edit International Service Band';
    else if (type === 'int-mu') title = isAdd ? 'Add International Meal Uplift' : 'Edit International Meal Uplift';

    const flatItem = item ? { ...item } : {};
    
    if (item?.meals && typeof item.meals === 'object') {
       Object.keys(item.meals).forEach(k => {
          flatItem[`meal_${k}`] = item.meals[k];
       });
    }
    
    if (item?.uplifts && typeof item.uplifts === 'object') {
       Object.keys(item.uplifts).forEach(k => {
          flatItem[`uplift_${k}`] = item.uplifts[k];
       });
    }

    setModalState({ isOpen: true, type, item: flatItem, title, errorMsg: '' });
  };

  const onModalChange = (e, mergedState) => {
     if (e && e.target && e.target.name) {
         const name = e.target.name;
         const val = e.target.value;
         
         setModalState(prev => ({
            ...prev,
            item: { ...prev.item, [name]: val },
            errorMsg: ''
         }));
     }
  };

  const validateItem = (type, item) => {
     const trimStr = str => typeof str === 'string' ? str.trim() : str;
     
     if (type === 'dom-sb' || type === 'int-sb') {
        const from = trimStr(item.from);
        const to = trimStr(item.to);
        const svc = trimStr(item.svc);
        
        if (from === '' || to === '' || svc === '' || svc === null || svc === undefined) return "From, To, and SVC are required.";
        if (isNaN(from) || isNaN(to)) return "From and To must be numeric.";
        if (Number(from) > Number(to)) return "From cannot be greater than To.";
        
        if (type === 'int-sb' && !trimStr(item.meals)) return "Meals is required.";
     }
     if (type === 'dom-msp' || type === 'int-mu') {
        const from = trimStr(item.from);
        const to = trimStr(item.to);
        const cat = trimStr(item.category);
        if (!from || !to || !cat) return "From, To, and Category are required.";
        const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        if (!timeRegex.test(from) || !timeRegex.test(to)) return "Time must be in HH:MM format (24-hour).";
        if (from > to) return "From time cannot be greater than To time.";
        
        if (type === 'dom-msp') {
           if (!trimStr(item.meals?.BC) || !trimStr(item.meals?.EY) || !trimStr(item.meals?.CO) || !trimStr(item.meals?.CR)) {
               return "BC, EY, CO, and CR meals are required.";
           }
        }
     }
     if (type === 'dom-sc') {
        if (!trimStr(item.svc) || !trimStr(item.category) || !trimStr(item.domesticServiceCategory)) return "SVC, Category, and Domestic Service Category are required.";
        if (!trimStr(item.meals?.BC) || !trimStr(item.meals?.EY)) return "BC and EY meals are required.";
     }
     return null;
  };

  const onModalSubmit = async () => {
     const { type, item } = modalState;
     
     const reconstructedItem = { ...item };
     
     if (type === 'dom-msp' || type === 'dom-sc') {
        reconstructedItem.meals = {
           BC: item.meal_BC || '',
           EY: item.meal_EY || '',
           ...(type === 'dom-msp' ? { CO: item.meal_CO || '', CR: item.meal_CR || '' } : {})
        };
        delete reconstructedItem.meal_BC;
        delete reconstructedItem.meal_EY;
        delete reconstructedItem.meal_CO;
        delete reconstructedItem.meal_CR;
     }
     
     if (type === 'int-mu') {
        reconstructedItem.uplifts = {};
        intUpliftLevels.forEach(lvl => {
           reconstructedItem.uplifts[lvl] = item[`uplift_${lvl}`] || '';
           delete reconstructedItem[`uplift_${lvl}`];
        });
     }

     const error = validateItem(type, reconstructedItem);
     if (error) {
        setModalState(prev => ({ ...prev, errorMsg: error }));
        return;
     }

     const newData = JSON.parse(JSON.stringify(data));
     
     let targetArray = [];
     if (type.startsWith('dom-')) {
        const coll = type === 'dom-sb' ? 'serviceBands' : type === 'dom-msp' ? 'mealServicePolicies' : 'serviceCategories';
        newData.domestic[coll] = newData.domestic[coll] || [];
        targetArray = newData.domestic[coll];
     } else {
        const coll = type === 'int-sb' ? 'serviceBands' : 'mealUplifts';
        newData.international[coll] = newData.international[coll] || [];
        targetArray = newData.international[coll];
     }

     if (!reconstructedItem.id) {
        let duplicateMsg = null;
        if (type === 'dom-sb' || type === 'int-sb') {
           if (targetArray.some(x => String(x.svc).trim() === String(reconstructedItem.svc).trim())) duplicateMsg = 'An entry with this SVC already exists.';
        } else if (type === 'dom-msp' || type === 'int-mu') {
           if (targetArray.some(x => String(x.category).trim().toLowerCase() === String(reconstructedItem.category).trim().toLowerCase())) duplicateMsg = 'An entry with this Category already exists.';
        } else if (type === 'dom-sc') {
           if (targetArray.some(x => String(x.svc).trim() === String(reconstructedItem.svc).trim() && String(x.category).trim().toLowerCase() === String(reconstructedItem.category).trim().toLowerCase())) duplicateMsg = 'An entry with this SVC and Category already exists.';
        }

        if (duplicateMsg) {
           setModalState(prev => ({ ...prev, errorMsg: duplicateMsg }));
           return;
        }

        reconstructedItem.id = `${type}-new-${Date.now()}`;
        targetArray.push(reconstructedItem);
     } else {
        const idx = targetArray.findIndex(x => x.id === reconstructedItem.id);
        if (idx !== -1) targetArray[idx] = reconstructedItem;
        else targetArray.push(reconstructedItem);
     }

     try {
        const res = await APIEndpoint.put(`mealPolicy?airlineId=${encodeURIComponent(currentAirline)}`, newData);
        if (res && res.domestic && res.international) {
           setData({
              domestic: res.domestic,
              international: res.international
           });
        } else {
           setData(newData);
        }
        toastSuccess('Meal policy updated successfully');
     } catch (err) {
        console.error('Error saving meal policy update:', err);
        toastError('Failed to save meal policy update');
     }

     setModalState({ isOpen: false, type: null, item: null, title: '', errorMsg: '' });
  };

  const getModalFields = () => {
     const { type, item } = modalState;
     if (!type) return [];
     const isEditing = Boolean(item && item.id);
     
     if (type === 'dom-sb') {
        return [
           { label: 'From (min)', attribute: 'from', type: 'text', required: true, initialValue: item?.from || '' },
           { label: 'To (min)', attribute: 'to', type: 'text', required: true, initialValue: item?.to || '' },
           { label: 'SVC', attribute: 'svc', type: 'text', required: true, disabled: isEditing, initialValue: item?.svc || '' }
        ];
     }
     if (type === 'dom-msp') {
        return [
           { label: 'From Time (HH:MM)', attribute: 'from', type: 'text', required: true, initialValue: item?.from || '' },
           { label: 'To Time (HH:MM)', attribute: 'to', type: 'text', required: true, initialValue: item?.to || '' },
           { label: 'Category', attribute: 'category', type: 'text', required: true, disabled: isEditing, initialValue: item?.category || '' },
           { label: 'BC Meal', attribute: 'meal_BC', type: 'text', required: true, initialValue: item?.meal_BC || '' },
           { label: 'EY Meal', attribute: 'meal_EY', type: 'text', required: true, initialValue: item?.meal_EY || '' },
           { label: 'CO Meal', attribute: 'meal_CO', type: 'text', required: true, initialValue: item?.meal_CO || '' },
           { label: 'CR Meal', attribute: 'meal_CR', type: 'text', required: true, initialValue: item?.meal_CR || '' }
        ];
     }
     if (type === 'dom-sc') {
        return [
           { label: 'SVC', attribute: 'svc', type: 'text', required: true, disabled: isEditing, initialValue: item?.svc || '' },
           { label: 'Category', attribute: 'category', type: 'text', required: true, disabled: isEditing, initialValue: item?.category || '' },
           { label: 'Domestic Service Category', attribute: 'domesticServiceCategory', type: 'text', required: true, disabled: isEditing, initialValue: item?.domesticServiceCategory || '' },
           { label: 'BC Meal', attribute: 'meal_BC', type: 'text', required: true, initialValue: item?.meal_BC || '' },
           { label: 'EY Meal', attribute: 'meal_EY', type: 'text', required: true, initialValue: item?.meal_EY || '' }
        ];
     }
     if (type === 'int-sb') {
        return [
           { label: 'From (min)', attribute: 'from', type: 'text', required: true, initialValue: item?.from || '' },
           { label: 'To (min)', attribute: 'to', type: 'text', required: true, initialValue: item?.to || '' },
           { label: 'SVC', attribute: 'svc', type: 'text', required: true, disabled: isEditing, initialValue: item?.svc || '' },
           { label: 'Meals', attribute: 'meals', type: 'text', required: true, initialValue: item?.meals || '' }
        ];
     }
     if (type === 'int-mu') {
        const fields = [
           { label: 'From Time (HH:MM)', attribute: 'from', type: 'text', required: true, initialValue: item?.from || '' },
           { label: 'To Time (HH:MM)', attribute: 'to', type: 'text', required: true, initialValue: item?.to || '' },
           { label: 'Category', attribute: 'category', type: 'text', required: true, disabled: isEditing, initialValue: item?.category || '' }
        ];
        intUpliftLevels.forEach(lvl => {
           fields.push({ label: `Uplift ${lvl}`, attribute: `uplift_${lvl}`, type: 'text', required: false, initialValue: item?.[`uplift_${lvl}`] || '' });
        });
        return fields;
     }
  };

  const actionStyle = { cursor: 'pointer', margin: '0 auto', display: 'block' };

  return (
    <div className='op-aircraft-container flexCol full-flex ag-theme-alpine-dark'>
      <ToastContainer />
      {loading && (
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={LoadingGIF} alt="Loading..." style={{ width: '60px', height: '60px' }} />
        </div>
      )}

      <div className="flexRow row justifyContentSpaceBetween">
        <div className="flexRow justifyContentSpaceBetween margBottom18">
          {state && state.sectorTypes ? (
            <div className='felxCol'>
              <label className="req margBottom10">Sector Type</label>
               <CustomSelect
                options={state.sectorTypes}
                width={'12rem'}
                value={state.sectorTypes.filter(option => state.sectorType && state.sectorType?.find(sc => sc?.label === option?.label))}
                placeHolder='Select Sector Type'
                onChange={handleSectorType}
                />
            </div>
          ) : null}
        </div>

        <div className="container-fluid dashboard-summary-container" style={{ overflow: "scroll", maxHeight: '85vh', width: '100%' }}>
          
          {/* DOMESTIC VIEW */}
          {state.sectorType.length && state.sectorType[0].value === 'domestic' ? (
            <div className="flexCol" style={{ width: '100%' }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className='flexCol margBottom18' style={{ width: '95%', maxWidth: '1400px', gap: '20px' }}>
                  
                  {/* Fallback Indicator */}
                  {domData.isFallback && (
                    <div style={{
                      background: 'rgba(255, 152, 0, 0.12)',
                      border: '1px solid #ff9800',
                      color: '#ffe0b2',
                      padding: '10px 16px',
                      borderRadius: '6px',
                      marginBottom: '5px',
                      fontSize: '13px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}>
                      <span>
                        ⚠️ <strong>Default configuration shown</strong> — airline-specific policy is not configured for <strong>{domData.airlineId || currentAirline}</strong>.
                      </span>
                      <span style={{ fontSize: '12px', opacity: 0.85 }}>
                        (Read-only default configuration)
                      </span>
                    </div>
                  )}

                  {/* Domestic Service Band */}
                  <div style={{ width: '100%' }}>
                    <div className="flexRow justifyContentSpaceBetween alignItemsCenter margBottom10">
                       <div style={{fontWeight:'bold'}}>Domestic Service Band</div>
                       {editMealPolicy && !domData.isFallback && <button type="button" onClick={() => onEdit('dom-sb', null)} className="add-item-button">+ Add New</button>}
                    </div>
                    {/* AG-GRID: table replaced */}
                    <MealGrid type="dom-sb" rowData={domData.serviceBands} columns={DOM_SB_COLS}
                      editable={editMealPolicy} isFallback={domData.isFallback} onEdit={onEdit} onDelete={onDelete} />
                  </div>

                  {/* Domestic Meal Service Policy */}
                  <div style={{ width: '100%' }}>
                    <div className="flexRow justifyContentSpaceBetween alignItemsCenter margBottom10">
                       <div style={{fontWeight:'bold'}}>Domestic Meal Service Policy (24hrs)</div>
                       {editMealPolicy && !domData.isFallback && <button type="button" onClick={() => onEdit('dom-msp', null)} className="add-item-button">+ Add New</button>}
                    </div>
                    {/* AG-GRID: table replaced */}
                    <MealGrid type="dom-msp" rowData={domData.mealServicePolicies} columns={DOM_MSP_COLS}
                      editable={editMealPolicy} isFallback={domData.isFallback} onEdit={onEdit} onDelete={onDelete} />
                  </div>

                {/* Domestic Service Category */}
                <div style={{ width: '100%' }}>
                    {/* SEARCH: title | centered search bar | add button */}
                    <div
                      className="margBottom10"
                      style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center' }}
                    >
                        <div style={{fontWeight:'bold'}}>Domestic Service Category</div>

                        <div className="underline" style={{ display: 'flex', alignItems: 'center' }}>
                          <span><img className="icon-size" alt="Search" src={searchIcon} /></span>
                          <span>
                            <input
                              className="search"
                              type="search"
                              placeholder="Search domestic service category"
                              value={scSearch}
                              onChange={(e) => setScSearch(e.target.value)}
                            />
                          </span>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          {editMealPolicy && !domData.isFallback && <button type="button" onClick={() => onEdit('dom-sc', null)} className="add-item-button">+ Add New</button>}
                        </div>
                    </div>
                    {/* AG-GRID: table replaced */}
                    <div style={{ marginBottom: '20px' }}>
                      <MealGrid type="dom-sc" rowData={filteredServiceCategories} columns={DOM_SC_COLS}
                        editable={editMealPolicy} isFallback={domData.isFallback} onEdit={onEdit} onDelete={onDelete} />
                    </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* INTERNATIONAL VIEW */}
          {state.sectorType.length && state.sectorType[0].value === 'international' ? (
            <div className="flexCol" style={{ width: '100%' }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className='flexCol' style={{ width: '95%', maxWidth: '1400px', gap: '20px' }}>
                  
                  {/* Fallback Indicator */}
                  {intData.isFallback && (
                    <div style={{
                      background: 'rgba(255, 152, 0, 0.12)',
                      border: '1px solid #ff9800',
                      color: '#ffe0b2',
                      padding: '10px 16px',
                      borderRadius: '6px',
                      marginBottom: '5px',
                      fontSize: '13px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}>
                      <span>
                        ⚠️ <strong>Default configuration shown</strong> — airline-specific policy is not configured for <strong>{intData.airlineId || currentAirline}</strong>.
                      </span>
                      <span style={{ fontSize: '12px', opacity: 0.85 }}>
                        (Read-only default configuration)
                      </span>
                    </div>
                  )}

                  {/* International Service Band */}
                  <div style={{ width: '100%', marginBottom: '20px' }}>
                  <div className="flexRow justifyContentSpaceBetween alignItemsCenter margBottom10">
                      <div style={{fontWeight:'bold'}}>International Service Band</div>
                      {editMealPolicy && !intData.isFallback && <button type="button" onClick={() => onEdit('int-sb', null)} className="add-item-button">+ Add New</button>}
                  </div>
                  {/* AG-GRID: table replaced */}
                  <MealGrid type="int-sb" rowData={intData.serviceBands} columns={INT_SB_COLS}
                    editable={editMealPolicy} isFallback={intData.isFallback} onEdit={onEdit} onDelete={onDelete} />
                </div>

                {/* International Meal Uplift */}
                <div style={{ width: '100%', marginBottom: '20px' }}>
                  <div className="flexRow justifyContentSpaceBetween alignItemsCenter margBottom10">
                      <div style={{fontWeight:'bold'}}>International Meal Uplift</div>
                      {editMealPolicy && !intData.isFallback && <button type="button" onClick={() => onEdit('int-mu', null)} className="add-item-button">+ Add New</button>}
                  </div>
                  {/* AG-GRID: table replaced */}
                  <MealGrid type="int-mu" rowData={intData.mealUplifts} columns={intMuCols}
                    editable={editMealPolicy} isFallback={intData.isFallback} onEdit={onEdit} onDelete={onDelete} />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      </div>

      {modalState.isOpen ? (
        <EditModal
          key={`${modalState.type}-edit`}
          title={modalState.title}
          className="airports-modal"
          showFieldsInColumn={true}
          columnViewType={true}
          onClose={onCloseEditMeals}
          onSubmit={onModalSubmit}
          onChange={onModalChange}
          fields={getModalFields()}
        >
           {modalState.errorMsg && (
              <div style={{ color: '#ff4d4f', marginTop: '10px', textAlign: 'center', gridColumn: '1 / -1' }}>
                 {modalState.errorMsg}
              </div>
           )}
        </EditModal>
      ) : null}

      {deleteState.isOpen && (
        <DeleteConf
          title="Delete Record"
          buttonStat={deleteState.isDeleting}
          onContinue={onConfirmDelete}
          onCloseDelete={() => setDeleteState({ isOpen: false, type: null, item: null, isDeleting: false })}
          description={`Are you sure you want to delete this record? This action cannot be undone.`}
        />
      )}

      {!ready && <div className='overlay_hide sub'></div>}
    </div>
  )
}